import React from 'react'

import { compose } from 'recompose'
import { connect } from 'react-redux'
import { connect as formikConnect } from 'formik'

import { debounce } from 'throttle-debounce'

import { getCloserLocations, getCloserLocationsLoading } from 'SRC/modules/geoObjects/closerLocations/selectors'
import { fetchCloserLocations } from 'SRC/modules/geoObjects/closerLocations/actions'

import { AdditionalPreloader } from 'SRC/ui/Preloader'

class CloserLocation extends React.Component {
  constructor (props) {
    super(props)

    const { fetchCloserLocations, formik } = props

		
    this.optionsRef = React.createRef()
    this.labelRef = React.createRef()
    this.textSearchRef = React.createRef()

    if (formik && formik.values && Number(formik.values.country) !== -1 && Number(formik.values.city) !== -1 &&
			formik.values.closerLocation !== -1)
		{
      fetchCloserLocations({
        search: formik.values.closerLocation,
        country: Number(formik.values.country),
        city: Number(formik.values.city)
      })
    }

		this.state = {
			isOptionsVisible: false
		}
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.toggleOptionsVisibility)
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.toggleOptionsVisibility)
  }

	setCloserLocation = (location) => {
		const { formik, setCloserLocationsText } = this.props

		formik.setFieldValue('closerLocation', location || -1)
		this.setState({ isOptionsVisible: false })
		setCloserLocationsText && setCloserLocationsText(location)
	}

	toggleOptionsVisibility = (e) => {
    let isOptionsVisible = false

    if (this.labelRef.current && this.labelRef.current.contains(e.target)) {
      console.log('toggleOptionsVisibility')
      isOptionsVisible = !this.state.isOptionsVisible
    }

    if (this.optionsRef.current && this.optionsRef.current.contains(e.target)) {
      isOptionsVisible = true
    }

    if (this.textSearchRef.current && this.textSearchRef.current.contains(e.target)) {
      console.log('toggleOptionsVisibility')
      isOptionsVisible = true
    }

    this.setState({ isOptionsVisible })
  }

  renderDropdown = () => {
    const { isOptionsVisible } = this.state
    const { closerLocations, closerLocationsLoading, formik, onCloserLocationClicked } = this.props

		const selectedCloserLocation = formik.values.closerLocation

    return isOptionsVisible ? (
      <div className='select-dropdown-container select-dropdown-single' ref={this.optionsRef}>
        <ul className='select-dropdown-items'>
          {closerLocationsLoading
            ? <AdditionalPreloader />
            : Array.isArray(closerLocations) && closerLocations.length
              ? closerLocations.map((item, index) => (
                <li key={item} className='select-dropdown-item'>
                  <input id={`cl-${item}`} type='checkbox' onChange={() => { this.setCloserLocation(item) }}
                    data-value={item} checked={item === selectedCloserLocation}
                  />

                  <label htmlFor={item}>
                    {item}
                  </label>
                </li>
              ))
              : <p style={{ padding: 5 }}>Nema lokacija</p>
          }
        </ul>
      </div>
    ) : null
  }

  render () {
    const {
			closerLocationsText,
			formik,
			onCloserLocationInput,
			closerLocationsLoading,
			setCloserLocationsText,
			fetchCloserLocations
		} = this.props

    const { isOptionsVisible } = this.state

		const selectedCloserLocation = formik.values.closerLocation

    console.log('selectedCloserLocation', selectedCloserLocation)
    console.log('closerLocationsText', closerLocationsText)

    const isAcceptEnabled = (selectedCloserLocation || '') !== closerLocationsText

    return (
      <div className='form-group form-group-closer-location'>
        <label ref={this.labelRef}>Bliža lokacija</label>
        <div className={`select-dropdown-picker`}>
          {isOptionsVisible && !closerLocationsLoading
            ? (
              <input
                ref={this.textSearchRef}
                defaultValue={closerLocationsText}
                type='text'
                onChange={debounce(1000, e => {
									const text = e.target.value
									console.log('text', text)
									setCloserLocationsText && setCloserLocationsText(text || '')

									const params = { size: 20, search: text }

									if (formik && formik.values.country && Number(formik.values.country) !== -1) {
										params.country = Number(formik.values.country)
									}

									if (formik && formik.values.city && Number(formik.values.city) !== -1) {
										params.city = Number(formik.values.city)
									}

									fetchCloserLocations(params)
								})}
              />
            ) : (
							<label ref={this.labelRef} className='select-dropdown-selected'>
								{closerLocationsText}
							</label>
					)}

          <span
            className={`accept${!isAcceptEnabled ? ' accept-disabled' : ''}`}
            onClick={() => this.setCloserLocation(closerLocationsText)}
          >
            <i className='ico-ima ico' />
          </span>
        </div>
        {this.renderDropdown()}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
		closerLocations: getCloserLocations(state),
		closerLocationsLoading: getCloserLocationsLoading(state)
	}
}

const enhance = compose(
	connect(mapStateToProps, { fetchCloserLocations }),
	formikConnect
)

export default enhance(CloserLocation)
